(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EventCollectionsController', EventCollectionsController);

    EventCollectionsController.$inject = ['EventCollections','EGSService',  'FileUploadService', 'SoopkitchenUtils',  '$scope'];

    function EventCollectionsController (EventCollections, EGSService,  FileUploadService, SoopkitchenUtils, $scope) {

    	var vm = this;

        /**** Properties ****/
        vm.eventCollections = [];
        vm.checked = {};
        vm.formatIsoZuluDateString = SoopkitchenUtils.formatIsoZuluDateString;
        vm.isUploading = false;
        vm.ascending = false;
        vm.predicate = 'timestamp';
        vm.egsParameters = [];

        /**** Methods ****/
        vm.uploadFiles = uploadFiles;
        vm.areChecked = areChecked;
        vm.merge = merge;
        vm.save = save;
        vm.abort = abort;
        vm.sortTable = sortTable;
        vm.isProcessFinished = isProcessFinished;
        vm.jobsStatusClass = EGSService.jobsStatusClass;
        vm.deleteCollection = EventCollections.openDeleteDialog;

        //Load Event Collections
        EventCollections.getEventCollections(
            successLoadingEventCollections,
            showError);

        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                $scope.$apply();
            });
        }

        function successLoadingEventCollections(response) {
            var data = response.data;
            for (var i = 0; i < data.length; i++) {
                var eventCollection = data[i];
                if (eventCollection.egsJob !== null) {
                    eventCollection.description = "Generated by EGS";
                    eventCollection.processStatus =eventCollection.egsJob.processStatus;
                } else {
                    eventCollection.processStatus = "N/A";
                }
                vm.eventCollections.push(eventCollection);
            }
            vm.eventCollections = SoopkitchenUtils.sort(vm.eventCollections, vm.predicate, !vm.ascending);
        }

        function sortTable() {
            vm.eventCollections = SoopkitchenUtils.sort(vm.eventCollections, vm.predicate, !vm.ascending);
            $scope.$apply();
        }

        function uploadFiles(files) {
            vm.files = files;
        }

        function successUpload(response) {
            const label = response.data.label;
            const validityStart = response.data.validityStartTime;
            const validityEndTime = response.data.validityEndTime;
            EventCollections.pickValidityDialog(label,  validityStart, validityEndTime);
        }

        function failureUpload(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.isUploading = false;
                $scope.$apply();
            });
        }

        function reloadCallback() {
            location.reload();
        }

        function abort(jobId) {
            EGSService.abort(jobId,
                function (response) {
                    SoopkitchenUtils.processResponse(
                        response,
                        "Job aborted",
                        "The EGS Job " + jobId + " has been aborted",
                        reloadCallback
                    );
                },
                function (response) {
                    SoopkitchenUtils.prettyError(response, reloadCallback);
                }
            );
        }

        function save () {
            if (vm.files && vm.files.length) {
                vm.isUploading = true;
                EventCollections.uploadEventCollection(vm.labelVal, vm.files, vm.description, successUpload, failureUpload)
            }
        }

        function areChecked() {
            var count = 0;
            for (var label in vm.checked) {
                if (vm.checked[label]) {
                    count++;
                }
            }
            return count;
        }

        function successMerge(response) {
            const label = response.data.label;
            const validityStart = response.data.validityStartTime;
            const validityEndTime = response.data.validityEndTime;
            EventCollections.pickValidityDialog(label,  validityStart, validityEndTime);
        }

        function failureMerge(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function merge() {
            EventCollections.merge(vm.checked, vm.labelVal,vm.description,  successMerge, failureMerge);
        }

        function isProcessFinished(eventCollection) {
            return eventCollection.egsJob===null || eventCollection.egsJob.processStatus==='COMPLETED';
        }
    }
})();
